// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './i18n/i18n'
import promise from 'es6-promise'
import 'babel-polyfill'
import Bus from './bus/eventBus'

import { getSession, setSession ,removeSession} from './assets/commonjs/local'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
//动态标题
import VueWechatTitle from 'vue-wechat-title';
//公共css
import './assets/style/common.css'
promise.polyfill();
Vue.use(VueWechatTitle);

// Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.Bus = Bus;
Vue.prototype.getSession = getSession;
Vue.prototype.setSession = setSession;
Vue.prototype.removeSession = removeSession;
Vue.prototype.$screenY = (n)=>{
  return document.documentElement.scrollTop = document.body.scrollTop = n;
};
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js